<template>
    <div>
        <div class="row">
            <div class="col-md-8 col-12 mt-auto mb-auto">
                <h3>Service Record</h3>

                <div class="row">
                    <div class="col-md mt-3 col-12">
                        <Multiselect 
                            :options="options.dealer.map(x => x.code)"
                            :custom-label="opt => options.dealer.find(x => x.code == opt).name"
                            v-model="filter.dealer"
                            placeholder="Pilih Dealer"
                        />
                    </div>
                    <div class="col-md mt-3 col-12">
                        <Multiselect 
                            :options="options.color.map(x => x.color)"
                            :custom-label="opt => options.color.find(x => x.color == opt).colorDesc"
                            v-model="filter.color"
                            placeholder="Pilih Warna Motor"
                        />
                    </div>
                    <div class="col-md mt-3 col-12">
                        <Multiselect 
                            :options="options.type.map(x => x.type)"
                            v-model="filter.type"
                            placeholder="Pilih Vehicle Type"
                        />
                    </div>
                    <div class="col-md mt-3 col-12">
                        <date-range-picker 
                            class="w-100 mr-4"
                            v-model="selectedDate"
                            style="min-height:43px"
                            ref="picker"
                            :opens="'left'"
                            :locale-data="{ firstDay: 1, format: 'MMM DD, YYYY' }"
                            
                        >
                            <template v-slot:input="picker" style="min-width: 350px;" class="text-center">
                                <i class="fa fa-calendar fa-fw ml-n1"></i> 
                                {{ moment(picker.startDate).format("DD/MM/YY")}} - {{ moment(picker.endDate).format("DD/MM/YY")}}
                                <b class="caret"></b>
                            </template>
                        </date-range-picker>
                    </div>
                </div>

            </div>
            <div class="col-md-4 col-12 mt-auto mb-auto">
                <Multiselect 
                    :options="typeRadiusOptions.map(x => x.value)"
                    :custom-label="opt => typeRadiusOptions.find(x => x.value == opt).name"
                    v-model="typeRadius"
                    :allow-empty="false"
                />

                <div class="row mt-2">
                    <div class="offset-md-5 col-md-4 mt-auto mb-auto">
                        <h6>Show Dealer Radius</h6>
                    </div>
                    <div class="col-md-3 text-right">
                        <toggle-button 
                            class=""
                            v-model="dealerRadius"
                            :width="50"
                            :height="25"
                            color="#7dCE94" 
                            :sync="true" 
                        />
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!filter.dealer" class="mt-4 text-center">
            <!-- {{data}} -->
            <h3>Dealer is required to use this feature.</h3>
        </div>
        <div v-else class="mt-4">

            <div class="row">
                <div class="col-lg-3 offset-lg-9 col-xs-4 offset-xs-8 col-12 mt-3 mb-3">
                    <button
                        class="w-100 btn btn-warning"
                        @click="downloadExcel"
                    >
                        <i class="fa fa-download"></i> Download Excel
                    </button>
                </div>
            </div>

            <div style="position:relative;">


                <div  class="" style="z-index:3;position:absolute;right:20px;bottom:30px;" :style="{'width' : hideLegend ? '30%': '15%'}" :noExpand="true">
                    <div class="row pl-3 rounded shadow" style="background-color:rgba(255 , 255, 255 ,1);margin-right:-20px">
                        <div class="col-1 mt-auto mb-auto" :class="{'col-12 pt-3 pb-3 pr-1' : !hideLegend}">
                            <i class="fa fa-chevron-right" v-if="hideLegend" @click="hideLegend = !hideLegend"></i>
                            <div  v-else @click="hideLegend = !hideLegend" class="hoverLegend p-2">
                                
                                <i class="fa fa-chevron-left" > Show Legend</i>
                            </div>
                        </div>
                        <div v-if="hideLegend" class="col-11 pl-3 pr-3">
                            
                            <div class="row">
                                <div class="col-md-6 pb-1 pt-2" v-for="(legend , index) in legendRadius" :key="'check' + index">
                                    <div class="input-group checkbox">
                                        <input class="form-check-input mt-0" type="checkbox" v-model="showLegend" :value="legend.findValue" aria-label="Checkbox for following text input" :id="'legend' + 1">
                                        <label class="smallbox--outerbox mb-0" for="check1">
                                            <div class="smallbox" :style="{'background-color' : legend.color}"></div>
                                            <p class="mb-0 pl-2">{{legend.name}}</p>
                                        </label>
                                    </div>
                                </div>
                                <!-- <div class="col-md-6">
                                    <div class="input-group checkbox">
                                        <input class="form-check-input mt-0" type="checkbox" value="" aria-label="Checkbox for following text input" id="check2">
                                        <label class="smallbox--outerbox mb-0" for="check2">
                                            <div class="smallbox ring2"></div>
                                            <p class="mb-0 pl-2">5 - 10 KM</p>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="input-group checkbox">
                                        <input class="form-check-input mt-0" type="checkbox" value="" aria-label="Checkbox for following text input" id="check3">
                                        <label class="smallbox--outerbox mb-0" for="check3">
                                            <div class="smallbox ring3"></div>
                                            <p class="mb-0 pl-2">10 - 15 KM</p>
                                        </label>
                                    </div>
                                </div> -->
                            </div>

                            <div class="row" style="border-top:1px solid black;">
                                <div class="col-md-8 pb-0">
                                    <label class="color-grey">Status</label>
                                </div>
                                <div class="col-md-4 pb-0">
                                    <label class="color-grey">Unit</label>
                                </div>
                            </div>
                            <div class="row mt-0">
                                <!-- <div class="col-md-2 mt-2" style="padding-top:5px;padding-bottom:3px"><span class="circle" style="width:0.75rem;height:0.75rem;background-color: #324aa8;border: 1px solid black;"></span></div> -->
                                <div class="col-md-8 pt-1" style="display: flex; align-items: center; flex-direction: row;">
                                    <div class="circle" style="background-color:#758694;height:1.25em;width:1.25em;"></div>
                                    <!-- <label class="mb-0 pl-2 font-weight-bold">Service in area</label> -->
                                    <label class="mb-0 pl-2 font-weight-bold">Qtrust</label>
                                </div>
                                <!-- <div class="col-md-6">
                                </div> -->
                                <div class="col-md-4 pt-1 font-weight-bold">
                                    <label>{{totalQtrust}}</label>
                                </div>
                            </div>
                            <div class="row mt-0">
                                <!-- <div class="col-md-2 mt-2" style="padding-top:5px;padding-bottom:3px"><span class="circle" style="width:0.75rem;height:0.75rem;background-color: #324aa8;border: 1px solid black;"></span></div> -->
                                <div class="col-md-8 pt-1" style="display: flex; align-items: center; flex-direction: row;">
                                    <div class="circle" style="background-color:#F21C1E;height:1.25em;width:1.25em;"></div>
                                    <!-- <label class="mb-0 pl-2 font-weight-bold">Service out of area</label> -->
                                    <label class="mb-0 pl-2 font-weight-bold">Brompit</label>
                                </div>
                                <!-- <div class="col-md-6">
                                </div> -->
                                <div class="col-md-4 pt-1 font-weight-bold">
                                    <label>{{totalBrompit}}</label>
                                </div>
                            </div>
                            <div class="row mt-0">
                                <!-- <div class="col-md-2 mt-2" style="padding-top:5px;padding-bottom:3px"><span class="circle" style="width:0.75rem;height:0.75rem;background-color: #324aa8;border: 1px solid black;"></span></div> -->
                                <div class="col-md-8 pt-1" style="display: flex; align-items: center; flex-direction: row;">
                                    <div class="circle" style="background-color:#324aa8;height:1.25em;width:1.25em;"></div>
                                    <!-- <label class="mb-0 pl-2 font-weight-bold">Others</label> -->
                                    <label class="mb-0 pl-2 font-weight-bold">sDMS</label>
                                </div>
                                <!-- <div class="col-md-6">
                                </div> -->
                                <div class="col-md-4 pt-1 font-weight-bold">
                                    <label>{{totalSdms}}</label>
                                </div>
                            </div>
                            <div class="row mt-0">
                                <!-- <div class="col-md-2 mt-2" style="padding-top:5px;padding-bottom:3px"><span class="circle" style="width:0.75rem;height:0.75rem;background-color: #324aa8;border: 1px solid black;"></span></div> -->
                                <div class="col-md-8 pt-1" style="display: flex; align-items: center; flex-direction: row;">
                                    <!-- <div class="circle" style="background-color:#324aa8;height:1.25em;width:1.25em;"></div> -->
                                    <!-- <label class="mb-0 pl-2 font-weight-bold">Others</label> -->
                                    <label class="mb-0 pl-2 font-weight-bold">PKB</label>
                                </div>
                                <!-- <div class="col-md-6">
                                </div> -->
                                <div class="col-md-4 pt-1 font-weight-bold">
                                    <label>{{totalPkb}}</label>
                                </div>
                            </div>
                            <div class="row mt-0">
                                <!-- <div class="col-md-2 mt-2" style="padding-top:5px;padding-bottom:3px"><span class="circle" style="width:0.75rem;height:0.75rem;background-color: #324aa8;border: 1px solid black;"></span></div> -->
                                <div class="col-md-8 pt-1" style="display: flex; align-items: center; flex-direction: row;">
                                    <!-- <div class="circle" style="background-color:#324aa8;height:1.25em;width:1.25em;"></div> -->
                                    <!-- <label class="mb-0 pl-2 font-weight-bold">Others</label> -->
                                    <label class="mb-0 pl-2 font-weight-bold">Repeat Service</label>
                                </div>
                                <!-- <div class="col-md-6">
                                </div> -->
                                <div class="col-md-4 pt-1 font-weight-bold">
                                    <label>{{totalRepeatService}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <l-map
                    :center="mapConfig.center"
                    :zoom="mapConfig.zoom"
                    ref="map"
                    style="min-height:650px;width:100%;z-index:0;position:relative"
                >   
                    <!-- Load Map Background (OpenStreetMap) -->
                    <l-tile-layer
                        :url="mapConfig.url"
                        :attribution="mapConfig.attribution"
                    />
                    <!-- Create White Background -->
                    <l-circle 
                        :lat-lng="latLng(mapConfig.center[0] , mapConfig.center[1])"
                        :radius="10000000"
                        :fillColor="'#FFFFFF'"
                        :fillOpacity="0.55"
                        :color="'#46769A'"
                        :weight="1"
                    />

                    <template v-if="dealerRadius">
                        <template v-if="typeRadius == 2">
                        
                            <l-geo-json
                                :geojson="geojsonOther"
                                :options="optionsFeatures"
                                :options-style="styleFunction('#C39E56')"
                            />
                            <l-geo-json
                                :geojson="geojsonRing1"
                                :options="optionsFeatures"
                                :options-style="styleFunction('#F21C1E')"
                            />
                            <l-geo-json
                                :geojson="geojsonRing2"
                                :options="optionsFeatures"
                                :options-style="styleFunction('#AF73F2')"
                            />
                            <l-geo-json
                                :geojson="geojsonRing3"
                                :options="optionsFeatures"
                                :options-style="styleFunction('#668DAB')"
                            />
                            <l-geo-json
                                :geojson="geojsonLocation"
                                :options="optionsFeatures"
                                :options-style="styleFunction('#CCE85A')"
                            />

                        </template>
                        <template v-else>
                            <div>
                                <template v-for="(circle , index) in configRadius">
                                    <l-circle 
                                        v-if="showLegend.includes(circle.findValue)"
                                        :key="index + 'RadiusCircle'"
                                        
                                        :lat-lng="latLng(mapConfig.center[0] , mapConfig.center[1])"
                                        :radius="circle.distance"
                                        :fillColor="circle.color"
                                        :fillOpacity="0"
                                        :color="circle.color"
                                        :weight="1"
                                    />
                                </template>
                            </div>
                        </template>
                    </template>

                    <l-marker :lat-lng="latLng(mapConfig.center[0] , mapConfig.center[1])" :icon="dealerMarkerIcon"  :zIndexOffset="1000">
                        <l-popup :content="'Dealer Name : <b>' + dealer.name + '</b>' "/>
                    </l-marker>

                    <l-marker v-for="(data , index) in points" :lat-lng="latLng(data.lat , data.lng)"  :icon="data.icon">
                        <l-tooltip :content="data.contentText"/>
                    </l-marker>
            
                </l-map>
            </div>
            

            <!-- {{data}} -->
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { ToggleButton } from 'vue-js-toggle-button'
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'

// Map stuff
import { latLng , icon , divIcon , map, geoJSON } from "leaflet";
import { LMap, LTileLayer, LMarker, LGeoJson, LIcon, LPopup, LTooltip, LCircle } from "vue2-leaflet";
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet/dist/leaflet.css"
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

export default {
    components : {
        Multiselect,
        ToggleButton,
        DateRangePicker,
        // Map Stuff
        LMap,
        LTileLayer,
        LIcon,
        LGeoJson,
        LMarker,
        LPopup,
        LTooltip,
        LCircle,
        'v-marker-cluster': Vue2LeafletMarkerCluster,
    },
    computed : {
        optionsFeatures() {
            return {
                onEachFeature: this.onEachFeatureFunction
            };
        },
        dealerMarkerIcon () {
            let height = 25
            let width = 25
            return icon({
                iconUrl: '/honda.png',
                iconSize:      [width, height], // size of the icon
                // iconAnchor:   [22, 94], // point of the icon which will correspond to marker's location
            });
        },
        onEachFeatureFunction() {
            return (feature, layer) => {
                // console.log(layer)
                if(feature.properties.typeDealer) {
                    layer.bindTooltip(
                        `</div><div>${feature.properties.typeDealer}: ` +
                        feature.properties.ADM3_EN +
                        "</div><div>Nama Kota: " +
                        feature.properties.ADM2_EN +
                        "</div><div>Total: "+
                        feature.properties.total 
                    ,
                    { permanent: false, sticky: true }
                    );
                }
                else {
                    layer.bindTooltip(
                        `</div><div>Nama Lokasi : ${feature.properties.display_name}</div>`
                    ,
                    { permanent: false, sticky: true }
                    );
                }
                
            };
        }
    },
    data () {
        let start = new moment().startOf('month').format("Y-MM-DD")
        let end = new moment().format("Y-MM-DD")

        return {
            // Library
            moment,
            latLng,
            // Variables
            typeRadius : 1,
            typeRadiusOptions : [{
                name : 'By Dealer Radius',
                value : 1
            },{
                name : 'By Kecamatan',
                value : 2
            },{
                name : 'By Dealer Range',
                value : 3
            }],
            dealerRadius : true,
            options : this.$store.getters.getFilterOptions,
            selectedDate : {
                startDate : start,
                endDate : end
            },
            filter : {
                dealer : null,
                start : start,
                end : end,
                type : null,
                color : null
            },
            data : null,
            // Maps
            mapConfig : {
                center : ["-7.257621004195039","112.75208164629598"],
                zoom : 11,
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                attribution:
                    '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            },
            dealer : null,
            points : null,
            hideLegend : true,
            geojsonOther : null,
            geojsonRing1 : null,
            geojsonRing2 : null,
            geojsonRing3 : null,
            geojsonLocation : null,
            geojson : null,
            loading : false,
            configRadius : [],
            area: [],
            total : 0,
            totalOutOfArea : 0,
            totalOthers: 0,
            totalQtrust: 0,
            totalSdms: 0,
            totalBrompit: 0,
            totalPkb: 0,
            totalRepeatService: 0,
            showLegend : ['ring1' , 'ring2' , 'ring3'],
            legendKecamatan : [{
                name : 'Other',
                findValue : 'OTHER',
                total : 0,
                color : '#C39E56'
            },{
                name : 'Ring 1',
                findValue : 'RING 1',
                total : 0,
                color : '#C39E56'
            },{
                name : 'Ring 2',
                findValue : 'RING 2',
                total : 0,
                color : '#C39E56'
            },{
                name : 'RING 3',
                findValue : 'RING 3',
                total : 0,
                color : '#C39E56'
            },{
                name : 'Lokasi',
                findValue : 'LOKASI',
                total : 0,
                color : '#C39E56'
            }],
            legendRadius : [{
                name : '0 - 5 KM',
                findValue : 'ring1',
                total : 0,
                color : '#938032'
            },{
                name : '5 - 10 KM',
                findValue : 'ring2',
                total : 0,
                color : '#F21C1E'
            },{
                name : '10 - 15 KM',
                findValue : 'ring3',
                total : 0,
                color : '#3388ff'
            }],
            legendShow : {
                radius : null,
                kecamatan : null
            }
        }
    },
    mounted () {
        this.loadAPI()
    },
    watch : {
        selectedDate : {
            deep : true,
            handler () {
                this.filter.start = new moment(this.selectedDate.startDate).format('Y-MM-DD')
			    this.filter.end = new moment(this.selectedDate.endDate).format('Y-MM-DD')
                this.loadAPI()
            }
        },
        'filter.dealer' : function () {
            this.loadAPI()
        },
        'filter.type' : function () {
            this.loadAPI()
        },
        'filter.color' : function () {
            this.loadAPI()
        }
    },
    methods : {
        styleFunction(fillColor) { // important! need touch fillColor in computed for re-calculate when change fillColor
            return {
                weight: 2,
                color: "#555",
                opacity: 1,
                fillColor: fillColor,
                fillOpacity: 0.36,
            };
        },
        async loadAPI(url = '/api/highlight/ttm-service-record?') {
            if (!this.filter.dealer) return;

            url = this.initialiseFilter(url , this.filter)

            try {
                const resp = await this.$http.get(url);
                let data = resp.data.data;
                this.processData(data);
                return data;  
            } catch (err) {
                console.log("API error:", err);
                throw err;  
            }
        },
        async downloadExcel() {
            if(this.filter.dealer){
                try {
                    const newData = await this.loadAPI('/api/highlight/download-ttm-service-record?');
                    this.data = newData;  
                    this.exportExcel(this.data, 'Service Record', 'Points');
                } catch (err) {
                    console.log("Error in downloading and exporting Excel:", err);
                }
            } 
        },
        async processData (data) {
            try {
                let dealerData = data.dealer
                let pkbData = data.total_pkb
                let repeatServiceData = data.total_repeat_service
                this.dealer = dealerData
                this.totalPkb = pkbData
                this.totalRepeatService = repeatServiceData
                this.total = 0
                this.totalOutOfArea = 0
                this.totalQtrust = 0
                this.totalSdms = 0
                this.totalBrompit = 0

                /* Load GEOJSON ( Use googleapi storage for Production ) */

                const response = await fetch(`https://storage.googleapis.com/mpm-geojson-id/Jawa%20Timur.json`)
                let jawaTimur = await response.json();
                const response2 = await fetch(`https://storage.googleapis.com/mpm-geojson-id/NTT.json`)
                let ntt = await response2.json();

                // const response = await fetch(`/Jawa%20Timur.json`)
                // let jawaTimur = await response.json();
                // const response2 = await fetch(`/NTT.json`)
                // let ntt = await response2.json();

                jawaTimur.features =  jawaTimur.features.concat(ntt.features)

                this.geojson = jawaTimur
                
                // Ring Config Distance (0-5 , 5-10 , 10-15 KM)
                let keys = Object.keys(dealerData)
            
                let arrayColor = ['#B177F2', '#938032' ,'#F21C1E']
                let curIndex = 0
                for(var i = 0 ; i < keys.length ; i++) {
                    
                    if(keys[i].includes('ring')) {
                        curIndex++;
                        let value = dealerData[keys[i]]
                        let splitName = keys[i].split('_')
                        let formattedName = `Ring ${splitName[1]}`

                        let obj = {
                            distance : value * 1000,
                            name : formattedName,
                            color : arrayColor[curIndex],
                            findValue : `ring${splitName[1]}`
                        }

                        this.configRadius.push(obj)
                    }
                }
                // Ring Config Distance End

                // Set Center of Map

                if(dealerData && !parseFloat(dealerData.lat) == 0 && !parseFloat(dealerData.lng) == 0)
                    this.mapConfig.center = [dealerData.lat , dealerData.lng]
                else
                    this.mapConfig.center = ["-7.257621004195039","112.75208164629598"]

                // Seperate Each Kecamatan By Ring Type

                let otherAreaDealer = dealerData.area.filter(x => x.ring == 'OTHER').map(x => {
                    return {
                        id_kecamatan : x.id_kecamatan,
                        service : x.service,
                        ring : x.ring
                    }
                })
                let ring3Dealer = dealerData.area.filter(x => x.ring == 'RING 3').map(x => {
                    return {
                        id_kecamatan : x.id_kecamatan,
                        service : x.service,
                        ring : x.ring
                    }
                })
                let ring2Dealer = dealerData.area.filter(x => x.ring == 'RING 2').map(x => {
                    return {
                        id_kecamatan : x.id_kecamatan,
                        service : x.service,
                        ring : x.ring
                    }
                })
                let ring1Dealer = dealerData.area.filter(x => x.ring == 'RING 1').map(x => {
                    return {
                        id_kecamatan : x.id_kecamatan,
                        service : x.service,
                        ring : x.ring
                    }
                })
                let locationDealer = dealerData.area.filter(x => x.ring == 'LOKASI').map(x => {
                    return {
                        id_kecamatan : x.id_kecamatan,
                        service : x.service,
                        ring : x.ring
                    }
                })

                this.legendShow.radius = Object.assign([] , this.legendRadius)
                this.legendShow.kecamatan = Object.assign([] , this.legendKecamatan)

                this.calculateFeatures('geojsonOther', 'Other' , otherAreaDealer , dealerData , null)
                this.calculateFeatures('geojsonRing1', 'Ring 1' , ring1Dealer , dealerData , null)
                this.calculateFeatures('geojsonRing2', 'Ring 2' , ring2Dealer , dealerData , null)
                this.calculateFeatures('geojsonRing3', 'Ring 3' , ring3Dealer , dealerData , null)
                this.calculateFeatures('geojsonLocation', 'Lokasi' , locationDealer , dealerData , null)

                // End Seperate Each Kecamatan By Ring Type

                // Process Points from Data
                let points = data.points.filter(x => x.lat != '' && x.lng != '')
                // let arrayKecamatan = dealerData.area.map(item => item.kecamatan)

                // let styleText = `
                //     width: 0.75rem;
                //     height: 0.75rem;
                //     display: block;
                    
                //     position: relative;
                //     left: 0rem;
                //     top: 0rem;
                //     background-color: #324aa8;
                //     border: 1px solid black;
                // `

                // let styleTextOufOfArea = `
                //     width: 0.75rem;
                //     height: 0.75rem;
                //     display: block;
                    
                //     position: relative;
                //     left: 0rem;
                //     top: 0rem;
                //     background-color: #F21C1E;
                //     border: 1px solid black;
                // `

                points.forEach(async (point) => {
                    point.contentText = `
                        Engine Number : <b>${ point.engine_no }</b><br>
                        Vehicle Type : <b>${ point.type }</b><br>
                        Commercial Name : <b>${ point.commercial_name ? point.commercial_name : '-' }</b><br>
                        Color : <b>${ point.color_description ? point.color_description : '-' }</b><br>
                        Service Date : <b>${(!point.last_service_date || point.last_service_date == '-' ?  '-' : moment(point.last_service_date).format('Y-MM-DD HH:mm'))}</b><br>
                        Lat : <b>${ point.lat }</b>, Lng :  <b>${ point.lng }</b><br>
                        Data Source : <b>${ point.notes ? point.notes : '-' }</b><br>
                    `

                    let dataSource = point.notes.split('_')[0];
                    let color = '758694';
                    if(dataSource == 'Brompit') {
                        color = 'F21C1E';
                        this.totalBrompit++;
                    } else if(dataSource == 'sDMS') {
                        color = '324aa8';
                        this.totalSdms++;
                    } else {
                        color = '758694';
                        this.totalQtrust++;
                    }
                    let styleText = `
                        width: 0.75rem;
                        height: 0.75rem;
                        display: block;
                        
                        position: relative;
                        left: 0rem;
                        top: 0rem;
                        background-color: #${color};
                        border: 1px solid black;
                    `

                    // let stylePoint = arrayKecamatan.includes(point.kecamatan) ? styleText : styleTextOufOfArea;
                    let html = `<span style="${styleText}" class="circle" />`
                    point.icon = divIcon({
                        className: "my-custom-pin",
                        iconAnchor: [0, 5],
                        labelAnchor: [-6, 0],
                        popupAnchor: [-12, -9],
                        html: html
                    })
                })


                this.points = points
                this.data = data
                this.totalOutOfArea = Number(points.length) - this.total
                this.totalOthers = Number(data.points.length) - Number(points.length)

            }
            catch(err) {
                console.log(err)
            }
        },
        calculateFeatures(selectedGeojson , typeDealer , areaDealer , dealerData , exclusion) {
            let obj = {
                type : 'FeatureCollection',
                features : []
            }

            for(var i = 0 ; i < this.geojson.features.length ; i++) {
                let curGeoJson = this.geojson.features[i]
                let selectedAreaDealer = areaDealer.find(x => x.id_kecamatan == curGeoJson.properties.ADM3_PCODE)
                if(selectedAreaDealer)
                {
                    obj.features.push(curGeoJson)
                    curGeoJson.properties.typeDealer = typeDealer
                    curGeoJson.properties.total = selectedAreaDealer.service
                    let legend = this.legendShow.kecamatan.find(x => x.findValue == selectedAreaDealer.ring)
                    legend.total += selectedAreaDealer.service
                    this.total += selectedAreaDealer.service
                }
            }

            this[selectedGeojson] = obj
        },
    }
}
</script>

<style>
.circle {
    border-radius: 3rem 3rem;
}

.color-grey {
    color: grey;
}

.smallbox--outerbox {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.smallbox {
    width: 1em;
    height: 1em;
    border-radius: 2px;
}

.checkbox.input-group .form-check-input {
    transform: translateY(20%);
}

.ring1 {
    background-color: red;
}

.ring2 {
    background-color: blue;
}

.ring3 {
    background-color: green;
}

</style>